import { assignSafe } from '@summit/core';
import { DivisionParameter } from '../division/division-parameter';

export class DivisionConfiguration {
  divisionId: string;
  employeeParameters: DivisionParameter; // what i can do
  reportParameters: DivisionParameter; // what i see

  constructor(jsonData?: Partial<DivisionConfiguration>) {
    if (jsonData) {
      assignSafe(this, jsonData);
      if (jsonData.reportParameters) {
        //console.log(`Division Configuration Report Parameters:`, jsonData.reportParameters);
        this.reportParameters = new DivisionParameter(jsonData.reportParameters);
      }
      if (jsonData.employeeParameters) {
        this.employeeParameters = new DivisionParameter(jsonData.employeeParameters);
      }
    }
  }

  isEquivalent(other: DivisionConfiguration): boolean {
    return (
      (this.employeeParameters?.isEquivalent(other?.employeeParameters) ?? false) &&
      (this.reportParameters?.isEquivalent(other?.reportParameters) ?? false)
    );
  }
}
